import React from "react";
import { useOctopusTheme } from "~/components/Theme/index";
export const PauseIcon = (): JSX.Element => {
    const theme = useOctopusTheme();
    return <em className={"fa-solid fa-exclamation-circle"} style={{ color: theme.danger }} aria-hidden="true"/>;
};
